<div *ngIf="questoes?.quesitos.length > 0" class="container p-0" >
  <div class="question-container row ml-0 mr-0">

    <!--Professor-->
    <section class="title-container">
      <div class="professor">
        <h1>{{ professor.nome }}</h1>
        <small>{{ professor.disciplina }}</small>
      </div>
    </section>

    <!--Foto-->
    <section class="image-container" style="width: auto;">
      <img [hidden]="false" [lazyLoad]="professorService.getImagem(professor.nomeArquivoFoto, 'baixa')" alt=""
        [defaultImage]="'assets/images/default.png'" *ngIf="!imageError" (error)="imageError = true" />
      <div *ngIf="!imageError">
        <circle-progress [radius]="90" [space]="-8" [percent]="porcentagemSelecionadas" [toFixed]="0" [showImage]="true"
          [outerStrokeGradient]="false" [outerStrokeWidth]="15" [outerStrokeColor]="'#00806F'"
          [innerStrokeColor]="'#fbfcfd'" [innerStrokeWidth]="1" [outerStrokeLinecap]="'square'" [animateTitle]="false"
          [animationDuration]="500" [showUnits]="false" [showBackground]="false" [imageWidth]="190" [imageHeight]="190">
        </circle-progress>
      </div>
      <div *ngIf="imageError">
        <circle-progress [radius]="90" [space]="-8" [percent]="porcentagemSelecionadas" [toFixed]="0" [showImage]="true"
          [outerStrokeGradient]="false" [outerStrokeWidth]="15" [outerStrokeColor]="'#00806F'"
          [innerStrokeColor]="'#fbfcfd'" [innerStrokeWidth]="1" [outerStrokeLinecap]="'square'" [animateTitle]="false"
          [animationDuration]="500" [showUnits]="false" [showBackground]="false"
          [imageSrc]="'assets/images/default.png'" [imageWidth]="190" [imageHeight]="190"></circle-progress>
      </div>
    </section>

    <section class="questions-container">

      <div class="title" *ngIf="professor.tipo != 1">
        Como você me avalia sobre:
      </div>

      <div class="title" *ngIf="professor.tipo == 1">
        Como você avalia sua escola sobre:
      </div>

      <div class="questions col-xs-12 pl-0 pr-0">

        <div class="load-spinner-content">
          <mat-progress-spinner *ngIf="salvando" class="spinner" color="warn" mode="indeterminate" value="50"
            diameter="25">
          </mat-progress-spinner>
        </div>

        <div class="pl-3 pr-3 resumo">
          <div class="indice">{{ indexSelecionado + 1 }}. </div>
          <div class="resumo-texto">{{ questaoSelecionada.resumo }}</div>
        </div>

        <div id="descricao">
          <p>{{ questaoSelecionada.descricao }}</p>
        </div>

        <div class="avaliacao" style="margin-bottom:21px" [ngClass]="{ disabled: (questoes.naoPossuiAulaComProfessor||questoes.naoSabeAvaliarProfessor) }">
          <button type="button"
            *ngFor="let opcoes of opcaoOrder(questoes.quesitos[indexSelecionado].opcoes, 'DESC'); let opcaoIndex = index" class="poa-opcao"
            (click)="selecionarOpcaoArray(opcaoIndex, indexSelecionado)"
            [disabled]="questoes.naoPossuiAulaComProfessor || questoes.naoSabeAvaliarProfessor || salvando"
            [class.active]="opcoes.hash == questoes.quesitos[indexSelecionado].hashOpcaoSelecionada">
            
            <i *ngIf="!opcoes.ocultarEmojis" [class.fa-laugh]="opcoes.legenda === 'A'" [class.fa-smile]="opcoes.legenda === 'B'"
              [class.fa-meh]="opcoes.legenda === 'C'" [class.fa-frown]="opcoes.legenda === 'D'" class="far"
              style="font-size: 6vh; height: 81%;"></i>

              <i *ngIf="opcoes.ocultarEmojis" class="far fa-circle" style="font-size: 16px; height: 81%;"></i>

            <span>{{ opcoes.nome }}</span>
          </button>
        </div>

        <div class="slider" [ngClass]="{ disabled: (questoes.naoPossuiAulaComProfessor||questoes.naoSabeAvaliarProfessor) }">
          <i *ngIf="indexSelecionado > 0" class="fas fa-long-arrow-left" (click)="!(questoes.naoPossuiAulaComProfessor||questoes.naoPossuiAulaComProfessor)
                      ? selecionarQuestao(indexSelecionado - 1)
                      : false"></i>
          <span *ngFor="let questao of questoes.quesitos; let questionIndex = index" (click)="!(questoes.naoPossuiAulaComProfessor||questoes.naoSabeAvaliarProfessor)
                      ? selecionarQuestao(questionIndex)
                      : false">
            <i class="fas fa-circle" [ngClass]="{ active: questao.selected }"></i>
          </span>

          <i *ngIf="arrowRight" class="fas fa-long-arrow-right" (click)="!(questoes.naoPossuiAulaComProfessor||questoes.naoSabeAvaliarProfessor)
                      ? selecionarQuestao(indexSelecionado + 1)
                      : false"></i>
        </div>

        <div class="col-xs-12" style="height: 10px;"></div>
        <!--
        <div class="jump-professor div-center">
          <div *ngIf="questoes.diferenciacao" class="col-xs-12">
            <input [checked]="questoes.naoPossuiAulaComProfessor" (change)="naoPossuiAulaProfessor($event.target.checked)"
              type="checkbox" id="checkbox-n" [disabled]="salvando || questoes.naoSabeAvaliarProfessor" name="checkbox" />
            <label for="checkbox-n"></label>
            <span>{{'questionario.questoes.naotenhoaula'|translate}}</span>
          </div>
        </div>
        -->
        <div class="" style="width: 100%;padding: 10px 20px;" *ngIf="!(questoes.naoPossuiAulaComProfessor||questoes.naoSabeAvaliarProfessor)">
          <app-comentarios-professor
            [professor]="professor"
            [aluno]="aluno"
            [reavaliado]="reavaliado"
            [comentarioProfessor]="professor.comentario"
            (respostaEnviada)="respostaEnviada()"
            (exibirListaProfessores)="exibirListaProfessores()"
            (comentarioFeedback)="reciverFeedback($event)"
            (reavaliadoFeedback)="reavaliadoFeedback($event)"
            (comentarioTexto)="capturarComentario($event)">
          </app-comentarios-professor>
        </div>

      </div>
    </section>

    <section class="questions-salvar">

      <div class="col-md-12 col-sm-12" style="padding-right: 0px;">
        <div class="btn-container">
          <div class="cancelar d-block d-lg-none d-xl-none">
            <button class="cancelar-button" (click)="cancelar()">
              <strong>
                {{ 'Cancelar' }}
              </strong>
            </button> <!-- -->
          </div>
          <app-button *ngIf="!loadingButtonSalvar" (click)="professor.tipo == 1 ? salvarAvaliacaoAdicional() : salvarAvaliacao()">
            <strong>
              {{ 'Salvar avaliação' }}
            </strong>
          </app-button>
          <button class="loading-button" *ngIf="loadingButtonSalvar">
            <strong>
              {{ 'Salvar avaliação' }}
            </strong>
            <mat-progress-spinner class="spinner" color="info" mode="indeterminate" value="50"
            diameter="25">
          </mat-progress-spinner>
          </button>
        </div>
      </div>

    </section>

  </div>
</div>


